import { Alert } from '@simplywallst/ui-core';

import { LinkStatusWrapper } from './styled';

const ResyncingState = () => {
  return (
    <LinkStatusWrapper>
      <Alert styleType="loading" data-cy-id="alert-resyncing-message">
        Retrieving your data. Refresh this page in a few minutes.
      </Alert>
    </LinkStatusWrapper>
  );
};

export default ResyncingState;
